import React from 'react';
import { Container } from './styles';

interface ToggleSwitchProps {
  checked: boolean;
  label: string;
  disabled: boolean;
  onChange: () => void;
}

const ToggleSwitch = ({ checked, label, disabled, onChange }: ToggleSwitchProps) => (
  <Container className={disabled ? 'disabled' : ''}>
    <input
      type="checkbox"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <span className="track" />
  </Container>
);

export default ToggleSwitch;
